import { ENTRY_GATE_VERIFY_QR, ENTRY_GATE_QR_LIST, ENTRY_GATE_UPDATE_ACCESS_PASS_LOG } from "../../utils/constants";


const initialState = [];

function entryGateReducer(state = initialState, action) {
    const { type, payload } = action

    switch (type) {
        case ENTRY_GATE_VERIFY_QR:
            return [...state, payload];
        case ENTRY_GATE_QR_LIST:
            return [...state, payload];
        case ENTRY_GATE_UPDATE_ACCESS_PASS_LOG:
            return [...state, payload];

        default:
            return state;
    }
};

export default entryGateReducer